module.exports = __webpack_public_path__ + "static/media/winbig-animated-header.4c72418c.png";